import { create } from "zustand";

// Ouverture du panneau de Léo (bulle flottante présente sur toutes les pages).
interface LeoState {
  open: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
}

export const useLeoStore = create<LeoState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
  toggle: () => set((s) => ({ open: !s.open })),
}));
